import type { FC } from "react";

interface Props {
  size?: number;
}

/** Figma `arrow-right` (node 8803:54686) — the filled horizontal arrow the pill CTA uses. Broadway has no right-arrow icon. */
export const ArrowRightIcon: FC<Props> = ({ size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M13.7652 8.54085C13.9152 8.39909 14.0001 8.20182 14 7.99547C13.9999 7.78912 13.9148 7.59194 13.7647 7.45033L9.2647 3.20449C8.96342 2.92023 8.48875 2.93402 8.20449 3.2353C7.92023 3.53658 7.93402 4.01125 8.2353 4.29551L11.3666 7.25L2.74992 7.25C2.3357 7.25 1.99992 7.58579 1.99992 8C1.99992 8.41421 2.3357 8.75 2.74992 8.75L11.3605 8.75L8.23477 11.705C7.93377 11.9896 7.92044 12.4642 8.20499 12.7652C8.48955 13.0662 8.96423 13.0796 9.26523 12.795L13.7652 8.54085Z"
      fill="currentColor"
    />
  </svg>
);
